import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// สีตามสถานะภาษาไทยที่ backend ส่งมาจริง (orderStatus.js)
const statusColor = {
  // Order ปกติ
  'รอคิว': '#888',
  'pending': '#888',
  'กำลังดำเนินการ': '#FF9500',
  'สำเร็จบางส่วน': '#FF9500',
  'สำเร็จ': '#34C759',
  'ยกเลิก': '#FF3B30',
  // Auto Like
  'กำลังอ่านโปรไฟล์': '#FF9500',
  'ทำงานอยู่': '#34C759',
  'หยุดชั่วคราว': '#FF9500',
  'ครบกำหนดแล้ว': '#34C759',
};

function HistoryPage({ user, dark }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const c = {
    bg: dark ? '#0d0d0d' : '#f8f8f8',
    card: dark ? '#1c1c1c' : '#ffffff',
    cardBorder: dark ? '#2e2e2e' : '#e8e8e8',
    text: dark ? '#eeeeee' : '#111111',
    sub: dark ? '#555555' : '#aaaaaa',
  };

  useEffect(() => {
    axios.get(`${BACKEND}/orders?lineUserId=${user.userId}`)
      .then(res => { setOrders(res.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [user]);

  if (loading) return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'200px'}}>
      <p style={{color:'#aaa',fontSize:'13px',fontFamily:'Prompt,sans-serif'}}>กำลังโหลดค่ะ...</p>
    </div>
  );

  return (
    <div style={{padding:'12px',display:'flex',flexDirection:'column',gap:'8px',background:c.bg,minHeight:'100vh',fontFamily:'Prompt,sans-serif'}}>

      <p style={{fontSize:'15px',fontWeight:'700',color:c.text,margin:'4px 0 8px'}}>ประวัติ order ค่ะ</p>

      {orders.length === 0 ? (
        <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',height:'200px',gap:'8px'}}>
          <i className="ti ti-clock" style={{fontSize:'40px',color:'#555'}} aria-hidden="true"/>
          <p style={{color:'#555',fontSize:'13px'}}>ยังไม่มี order ค่ะ</p>
        </div>
      ) : (
        orders.map(order => {
          const isAutoLike = order.services?.type === 'Subscriptions';
          const totalPosts = order.quantity || 0;
          const postsDone = order.posts_done || 0;
          const progressPct = totalPosts > 0 ? Math.min(100, (postsDone / totalPosts) * 100) : 0;

          return (
            <div key={order.id} style={{background:c.card,border:`1px solid ${c.cardBorder}`,borderRadius:'12px',padding:'12px 14px'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'6px'}}>
                <div style={{flex:1,marginRight:'8px'}}>
                  <p style={{fontSize:'12px',fontWeight:'600',color:c.text,margin:0}}>{order.services?.name}</p>
                  <p style={{fontSize:'10px',color:c.sub,margin:'2px 0 0',wordBreak:'break-all'}}>{order.link}</p>
                </div>
                <span style={{
                  fontSize:'9px',fontWeight:'600',padding:'3px 7px',borderRadius:'20px',flexShrink:0,
                  background:dark?'#1a1a1a':'#f5f5f5',
                  color:statusColor[order.status] || '#888'
                }}>
                  {order.status === 'pending' ? 'รอคิว' : order.status}
                </span>
              </div>

              {isAutoLike && (
                <div style={{display:'flex',alignItems:'center',gap:'8px',margin:'8px 0 6px'}}>
                  <div style={{flex:1,height:'6px',background:dark?'#252525':'#eee',borderRadius:'3px',overflow:'hidden'}}>
                    <div style={{height:'100%',width:`${progressPct}%`,background:'#FF4500',borderRadius:'3px'}}/>
                  </div>
                  <span style={{fontSize:'10.5px',color:'#FF4500',fontWeight:'600',whiteSpace:'nowrap'}}>
                    {postsDone}/{totalPosts} โพสต์
                  </span>
                </div>
              )}

              {order.refund_amount > 0 && (
                <p style={{fontSize:'10px',color:'#38bdf8',margin:'4px 0 0'}}>
                  💰 คืนเครดิตแล้ว {Number(order.refund_amount).toLocaleString()} {order.services?.unit_label || 'หน่วย'}
                </p>
              )}

              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:'6px'}}>
                <p style={{fontSize:'10px',color:c.sub,margin:0}}>
                  {new Date(order.created_at).toLocaleDateString('th-TH')}
                  {!isAutoLike && ` · ${order.quantity?.toLocaleString()} ${order.services?.unit_label || 'หน่วย'}`}
                </p>
                <p style={{fontSize:'10px',color:'#FF4500',fontWeight:'600',margin:0}}>
                  #{order.panel_order_id}
                </p>
              </div>
            </div>
          );
        })
      )}

    </div>
  );
}

export default HistoryPage;